"use strict";

require("core-js/modules/es.object.define-property.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.array.is-array.js");

var _dom = require("element-ui/lib/utils/dom");

var isRoot = function isRoot(binding) {
  return binding && binding.modifiers ? binding.modifiers.root : false;
};

var getReference = function getReference(el, binding, vnode) {
  var _ref = binding.expression ? binding.value : binding.arg;

  var popper = vnode.context.$refs[_ref];

  if (popper) {
    if (Array.isArray(popper)) {
      popper[0].$refs.reference = el;
    } else {
      popper.$refs.reference = el;
    }
  }

  return popper;
};

var _handleMouseEnter = function _handleMouseEnter(el, binding, vnode) {
  return function () {
    var popper = vnode.context.$root.popover;
    popper.$refs.reference = el;

    if (popper) {
      popper.init();
    }
  };
};

var _handleMouseLeave = function _handleMouseLeave(vnode) {
  return function () {
    var popper = vnode.context.$root.popover;

    if (popper) {
      popper.destroyEvent();
    }
  };
};

var _default = {
  bind: function bind(el, binding, vnode) {
    !isRoot(binding) && getReference(el, binding, vnode);
  },
  inserted: function inserted(el, binding, vnode) {
    if (isRoot(binding)) {
      var vm = vnode.context;
      vm._handleMouseLeave = _handleMouseLeave(vnode);
      vm._handleMouseEnter = _handleMouseEnter(el, binding, vnode);
      (0, _dom.on)(el, 'mouseleave', vm._handleMouseLeave);
      (0, _dom.on)(el, 'mouseenter', vm._handleMouseEnter);
    } else {
      getReference(el, binding, vnode);
    }
  },
  unbind: function unbind(el, binding, vnode) {
    if (isRoot(binding)) {
      var vm = vnode.context;
      (0, _dom.off)(el, 'mouseleave', vm._handleMouseLeave);
      (0, _dom.off)(el, 'mouseenter', vm._handleMouseEnter);
    }
  }
};
exports["default"] = _default;